import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import Chip from 'material-ui/Chip'
import Divider from 'material-ui/Divider'
import DatePicker from 'material-ui/DatePicker'
import RaisedButton from 'material-ui/RaisedButton'
import Dialog from 'material-ui/Dialog';

import {Tabs, Tab} from 'material-ui/Tabs'

//import CustomTabs from './tabs-invite'

const styles = {

    headline: {
      fontSize: 24,
      paddingTop: 16,
      marginBottom: 25,
      fontWeight: 400,
      textAlign: 'center'
    },

card: {
    marginBottom: '20px'
},

date: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '5px'
},

date2: {
    marginTop: '20px',
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '5px'
},

toptext: {
    marginLeft: '20px',
    marginRight: '20px',
    paddingBottom: '5px'
},

midtext: {
    marginLeft: '20px',
    marginRight: '20px',
},

midheader: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '1px',
    fontSize: '14px',
    fontWeight: 'bolder',
    textTransform: 'uppercase'
},

roll: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '10px',
    fontSize: '18px',
    fontWeight: 'bolder'
},

space: {
    height: '60px'
},

spacetop: {
    height: '20px'
},

space2: {
    height: '80px'
},

dialogstyle: {
    marginLeft: '20px',
    marginRight: '20px'
},

cardone: {
    marginTop: '25px',
    marginBottom: '25px'

},

button: {
    margin: 12
},

pcenter: {
    textAlign: 'center'
}

}

export default class OnOffTabs extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: 'a',
      openOnCampusDialog: false,
      openOffCampusDialog: false
    };
    this.handleOnCampusOpen = this.handleOnCampusOpen.bind(this)
    this.handleOnCampusClose = this.handleOnCampusClose.bind(this)
    this.handleOnCampusSubmit = this.handleOnCampusSubmit.bind(this)

    this.handleOffCampusOpen = this.handleOffCampusOpen.bind(this)
    this.handleOffCampusClose = this.handleOffCampusClose.bind(this)
    this.handleOffCampusSubmit = this.handleOffCampusSubmit.bind(this)
  }

  handleOnCampusSubmit = () => {
    const currentUser = this.props.currentUser
    this.props.updateStudentRecord(currentUser, { isOnCampus: true })
    this.handleOnCampusClose()
  }

  handleOnCampusOpen = () => {
    this.setState({openOnCampusDialog: true});
  };

  handleOnCampusClose = () => {
    this.setState({openOnCampusDialog: false});
  };

  handleOffCampusSubmit = () => {
    const currentUser = this.props.currentUser
    this.props.updateStudentRecord(currentUser, { isOnCampus: false })
    this.handleOffCampusClose()
  }

  handleOffCampusOpen = () => {
    this.setState({openOffCampusDialog: true});
  };

  handleOffCampusClose = () => {
    this.setState({openOffCampusDialog: false});
  };


  handleChange = (value) => {
    this.setState({
      value: value,
    });
  };

  render() {
    const actionsOnCampus = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleOnCampusClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        disabled={this.props.currentUser.isOnCampus === true || this.props.currentUser.isOnCampus === false}
        onTouchTap={this.handleOnCampusSubmit}
      />,
    ];

    const actionsOffCampus = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleOffCampusClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        disabled={this.props.currentUser.isOnCampus === true || this.props.currentUser.isOnCampus === false}
        onTouchTap={this.handleOffCampusSubmit}
      />,
    ];
    return (

      <Tabs
        value={this.state.value}
        onChange={this.handleChange}
      >
        <Tab label="On Campus" value="a" >
        <div>
          <h2 style={styles.headline}>Confirm On Campus Housing</h2>
          <p style={styles.pcenter}>
              <RaisedButton label="Confirm On Campus" secondary={true} style={styles.buttton} onTouchTap={this.handleOnCampusOpen} />
              <Dialog
                title="Are you sure you want to declare on campus housing?"
                actions={actionsOnCampus}
                modal={true}
                open={this.state.openOnCampusDialog}
              >
                Only actions can close this dialog.
              </Dialog>
          </p>
        </div>

        </Tab>

        <Tab label="Off Campus" value="b">
          <div>
            <h2 style={styles.headline}>Confirm Off Campus Housing</h2>
            <p style={styles.pcenter}>
                <RaisedButton label="Confirm Off Campus" secondary={true} style={styles.buttton} onTouchTap={this.handleOffCampusOpen}/>
                <Dialog
                  title="Are you sure you want to declare off campus housing?"
                  actions={actionsOffCampus}
                  modal={true}
                  open={this.state.openOffCampusDialog}
                >
                  Only actions can close this dialog.
                </Dialog>
            </p>
          </div>
        </Tab>

      </Tabs>

    );
  }
}



// WEBPACK FOOTER //
// ./src/views/pages/on-off-campus/tabs.js